import { Typography, TypographyProps } from '@mui/material';
import moment from 'moment';
import invariant from 'tiny-invariant';

import { IOptionalDateWindow } from '../../types/datetimes';
import { NullableFormattedDate } from '../../utils/datetimes/formatting';
import { VisitSingleDateDisplay } from '../dates/CommonDateDisplays';
import { CaptionLabel } from '../labels/CaptionLabel';
import { NoneLabel } from '../labels/NoneLabel';
import { VerticalStack } from '../utils/linearLayouts';

export interface IOptionalDateFulfillmentWindowDisplayProps {
    fulfillmentWindow: IOptionalDateWindow;
    labelProps?: TypographyProps;
    dateProps?: TypographyProps;
    collapseSingleDayWindows?: boolean;
    label?: boolean;
}

export function OptionalDateFulfillmentWindowDisplay({
    dateProps = {},
    labelProps = {},
    fulfillmentWindow: { startDate, endDate },
    collapseSingleDayWindows = true,
    label = true,
}: IOptionalDateFulfillmentWindowDisplayProps) {
    const startMoment = startDate ? moment(startDate) : null;
    const endMoment = endDate ? moment(endDate) : null;
    if (startDate && endDate) {
        invariant(startMoment && endMoment);
        if (collapseSingleDayWindows && startMoment.isSame(endMoment, 'day')) {
            return (
                <VisitSingleDateDisplay
                    startDate={startDate}
                    label={label}
                    labelProps={labelProps}
                    datetimeProps={{
                        fontSize: '14px',
                        ...dateProps,
                    }}
                />
            );
        }
        return (
            <VerticalStack>
                {label ? (
                    <CaptionLabel fontSize={'0.8em'} {...labelProps}>
                        Fulfillment Window
                    </CaptionLabel>
                ) : null}
                <Typography fontSize={'14px'} {...dateProps}>
                    <NullableFormattedDate date={startMoment} /> -{' '}
                    <NullableFormattedDate date={endMoment} />
                </Typography>
            </VerticalStack>
        );
    }
    if (startDate) {
        return (
            <VerticalStack>
                {label ? (
                    <CaptionLabel fontSize={'0.8em'} {...labelProps}>
                        Fulfillment Window
                    </CaptionLabel>
                ) : null}
                <Typography fontSize={'14px'} {...dateProps}>
                    After <NullableFormattedDate date={startMoment} />
                </Typography>
            </VerticalStack>
        );
    }
    if (endDate) {
        return (
            <VerticalStack>
                {label ? (
                    <CaptionLabel fontSize={'0.8em'} {...labelProps}>
                        Fulfillment Window
                    </CaptionLabel>
                ) : null}
                <Typography fontSize={'14px'} {...dateProps}>
                    Before <NullableFormattedDate date={endMoment} />
                </Typography>
            </VerticalStack>
        );
    }
    return <NoneLabel fontSize={'14px'} />;
}
